import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import MRUAttachmentStore from './schema/MRUAttachmentStore';

const initialMRUAttachmentStore: MRUAttachmentStore = {
    attachments: [],
    traceId: null,

    contextualAttachmentSuggestions: new ObservableMap({}),
    referenceItemIdAndComposeIdMap: new ObservableMap({}),
};

const getMRUAttachmentStore = createStore<MRUAttachmentStore>(
    'MRUAttachmentStore',
    initialMRUAttachmentStore
);

export default getMRUAttachmentStore;
